import React from 'react'
import { getSrc } from 'gatsby-plugin-image'
import { graphql, useStaticQuery } from 'gatsby'

const SEO: React.FC<React.PropsWithChildren<{ post: any; title?: string }>> = ({
    children,
    post,
    title,
}) => {
    const seo = post?.seo
    const robotsIndex =
        seo?.metaRobotsNoindex === 'noindex' ? 'noindex' : 'index'
    const robotsFollow =
        seo?.metaRobotsNofollow === 'nofollow' ? 'nofollow' : 'follow'
    const metaDescription = seo?.metaDesc ? seo.metaDesc : ''

    const metaTitle = title || seo?.title

    const ogImage = getSrc(seo?.opengraphImage?.localFile)
    const twitterImage = getSrc(seo?.twitterImage?.localFile)

    const fullSchema = seo?.schema?.raw

    const data = useStaticQuery(
        graphql`
            {
                wp {
                    favicon {
                        mediaDetails {
                            sizes {
                                sourceUrl
                                width
                            }
                        }
                    }
                }
            }
        `
    )
    const favicon = data?.wp?.favicon?.mediaDetails?.sizes || []

    return (
        <>
            <title>{title}</title>
            <meta
                name="robots"
                content={`max-snippet:-1, max-image-preview:large, max-video-preview:-1, ${robotsIndex}, ${robotsFollow}`}
            />
            <meta name="description" content={metaDescription} />

            {favicon?.length > 0 &&
                favicon.map(({ width, sourceUrl }) => {
                    if (width === '180') {
                        return (
                            <link
                                key={`fav-${width}x${width}`}
                                rel="apple-touch-icon"
                                href={sourceUrl}
                                sizes={`${width}x${width}`}
                            />
                        )
                    }
                    return (
                        <link
                            key={`fav-${width}x${width}`}
                            rel="icon"
                            type="image/png"
                            sizes={`${width}x${width}`}
                            href={sourceUrl}
                        />
                    )
                })}

            <meta name="og:title" content={seo?.opengraphTitle || metaTitle} />
            <meta
                name="og:description"
                content={seo?.opengraphDescription || metaDescription}
            />
            <meta
                name="og:locale"
                content={
                    seo?.schema?.inLanguage
                        ? seo.schema.inLanguage.replace('-', '_')
                        : null
                }
            />
            <meta name="og:type" content="website" />
            <meta
                name="og:image"
                content={ogImage || seo?.opengraphImage?.sourceUrl}
            />
            <meta name="og:image:alt" content={seo?.opengraphImage?.altText} />

            <meta
                name="twitter:title"
                content={seo?.twitterTitle || metaTitle}
            />
            <meta
                name="twitter:description"
                content={seo?.twitterDescription || metaDescription}
            />
            <meta
                name="twitter:image"
                content={twitterImage || seo?.twitterImage?.sourceUrl}
            />
            <meta
                name="twitter:image:alt"
                content={seo?.twitterImage?.altText}
            />

            {fullSchema && (
                <script type="application/ld+json" defer>{fullSchema}</script>
            )}

            {children}
        </>
    )
}

export default SEO
